import { Bell, Pin, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAnnouncements } from "@/hooks/useAnnouncements";
import { cn } from "@/lib/utils";

/** Inline banner shown above app content for unread warning/pinned announcements. */
export const AnnouncementsBanner = () => {
  const { visible, isRead, dismiss, markRead } = useAnnouncements();

  const banner = visible.find(
    (a) => !isRead(a.id) && (a.severity === "warning" || a.is_pinned),
  );

  if (!banner) return null;

  const tone =
    banner.severity === "warning"
      ? "bg-amber-500/15 border-amber-500/40 text-amber-900 dark:text-amber-100"
      : "bg-primary/10 border-primary/30 text-foreground";

  return (
    <div className={cn("border-b px-4 py-2 flex items-center gap-3", tone)}>
      {banner.is_pinned ? (
        <Pin className="h-4 w-4 shrink-0" />
      ) : (
        <Bell className="h-4 w-4 shrink-0" />
      )}
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium truncate">{banner.title}</p>
        {banner.body_md && (
          <p className="text-xs text-muted-foreground truncate">{banner.body_md.split("\n")[0]}</p>
        )}
      </div>
      <Button size="sm" variant="ghost" onClick={() => markRead(banner.id)}>
        Got it
      </Button>
      <Button
        size="icon"
        variant="ghost"
        className="h-7 w-7"
        onClick={() => dismiss(banner.id)}
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};
